import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css']
})
export class AdminLoginComponent implements OnInit {
  private returnUrl: string;
  user = {
    email: '',
    password: ''
  };


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {

    if (this.cookieService.check('token')) {
      const currentRole = this.cookieService.get('role');
      this.router.navigate([`/${currentRole}`]);
      return;
    }

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
  }

  login() {
    this.authService.login('admin', this.user)
      .subscribe(response => {
        if (response && response.success) {
          this.cookieService.set('token', response.data.token, null, '/');
          this.cookieService.set('user', JSON.stringify(response.data), null, '/');
          this.cookieService.set('role', 'admin', null, '/');
          this.router.navigate([this.returnUrl]);
        }
      });
  }

}
